import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

/**
 * Handles deep links opened from outside the app (e.g. password reset, OAuth callbacks).
 */
export const useDeepLinks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return;

    let listener: any;

    const setup = async () => {
      const { App } = await import("@capacitor/app");

      listener = await App.addListener("appUrlOpen", ({ url }) => {
        try {
          const parsed = new URL(url);
          const path = parsed.pathname + parsed.search + parsed.hash;

          if (path && path !== "/") {
            navigate(path, { replace: true });
          }
        } catch (e) {
          console.error("Deep link parse error:", e);
        }
      });
    };

    setup();

    return () => {
      listener?.remove?.();
    };
  }, [navigate]);
};
